
import React from "react";

interface OnboardingSectionProps {
  id: string;
  number: number;
  title: string;
  subtitle: string;
  children: React.ReactNode;
  className?: string;
}

const OnboardingSection: React.FC<OnboardingSectionProps> = ({
  id,
  number,
  title,
  subtitle,
  children,
  className = "",
}) => {
  return (
    <section id={id} className={`scroll-mt-20 ${className}`}>
      <div className="flex items-center gap-4 mb-6">
        <div className="h-12 w-12 rounded-full bg-sauna-orange text-white flex items-center justify-center text-xl font-bold">
          {number}
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-sauna-navy">{title}</h2>
          <p className="text-gray-500">{subtitle}</p>
        </div>
      </div>
      <div className="pl-0 md:pl-16">
        {children}
      </div>
    </section>
  );
};

export default OnboardingSection;
